import useTheme from '@/theme/useTheme';
import { Typography } from '@mui/material';
import Link from 'next/link';
import { Trans } from 'next-i18next';
import { isWoWSpaceView } from '@/utils/checkRuntime';

const TermsAndConditions = (props: any) => {
  const { theme } = useTheme();

  if (isWoWSpaceView) {
    return (
      <Typography
        variant="caption"
        color={theme.palette.text.secondary}
        fontWeight={100}
        textAlign={'start'}
        {...props}
      >
        By accessing the site, I attest that I am at least 18 years old and have
        read the{' '}
        <TermsAndConditionsLink>Terms & Conditions</TermsAndConditionsLink>.
      </Typography>
    );
  }

  return (
    <Typography
      variant="caption"
      color={theme.palette.text.secondary}
      fontWeight={100}
      textAlign={'start'}
      {...props}
    >
      <Trans
        i18nKey="common.termsAndConditions"
        components={{
          links: <TermsAndConditionsLink />,
        }}
      />
    </Typography>
  );
};

export const TermsAndConditionsLink = (props) => {
  const { theme } = useTheme();
  if (isWoWSpaceView) {
    // return null;
  }

  return (
    <Link
      style={{
        color: theme.palette.primary.main,
        textDecoration: 'underline',
      }}
      href="/help/general-bonuses-terms-conditions"
      target={'_blank'}
      {...props}
    />
  );
};

export default TermsAndConditions;
